module.exports = __webpack_public_path__ + "static/media/rj_result_traffic2.ef44821f.png";